
import { defineComponent, PropType } from 'vue';
import { Service } from '@/modules/nodesCanvasModule/components/storeClasses/service';
import { Topic } from '@/modules/nodesCanvasModule/components/storeClasses/topic';
import { Node } from '@/modules/nodesCanvasModule/components/storeClasses/node';
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';

export interface popupItem {
  type: string;
  name: string;
}
export default defineComponent({
  name: 'ControlPackage',
  data(): {
    showButtons: boolean;
    editedName: string;
    editingName: boolean;
  } {
    return {
      showButtons: false,
      editedName: this.packageName,
      editingName: false
    };
  },
  props: {
    robotPackage: {
      type: Boolean,
      required: false,
      default: false
    },
    packageName: {
      type: String,
      required: true
    },
    packageId: {
      type: String,
      required: true
    },
    topics: {
      type: Array as PropType<Array<string | Topic>>,
      required: false,
      default: []
    },
    services: {
      type: Array as PropType<Array<string | Service>>,
      required: false,
      default: []
    },
    nodes: {
      type: Array as PropType<Array<string | Node>>,
      required: false,
      default: []
    },
    openWindow: {
      type: Function as PropType<(pkgId: string, filter: string) => void>,
      required: false,
      default: () => {}
    },
    workspaceId: {
      type: String,
      required: true
    },
    editing: {
      type: Boolean,
      required: false,
      default: false
    },
    onInputSave: {
      type: Function as PropType<(name: string) => void>,
      required: false,
      default: (name: string) => {}
    },
    onDelete: {
      type: Function as PropType<() => void>,
      required: false,
      default: () => {}
    }
  },
  methods: {
    getItems(): Array<{ name: string; type: string }> {
      return [
        ...this.topics.map((topic) => {
          return {
            name:
              (typeof topic !== 'string' && topic.name) || (topic as string),
            type: 'topic'
          };
        }),
        ...this.services.map((service) => {
          return {
            name:
              (typeof service !== 'string' && service.name) ||
              (service as string),
            type: 'service'
          };
        }),
        ...this.nodes.map((node) => {
          return {
            name: (typeof node !== 'string' && node.name) || (node as string),
            type: 'node'
          };
        })
      ];
    },
    editClicked() {
      if (this.editingName) this.onInputSave(this.editedName);
      this.editingName = !this.editingName;
    },
    submitInput() {
      console.log('submitting input');
      this.onInputSave(this.editedName);
      this.editingName = false;
    }
  },
  watch: {
    editing(value, oldvalue) {
      if (!value) this.editingName = false;
    }
  }
});
